<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <span>練習問題</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="width-2">練習問題画面</td>
          <td>
            <router-link
              :to="{
                name: 'List General OF Section',
                params: { section: $route.params.section },
                query: {
                  season: $route.query.season,
                  section: $route.query.section,
                  chapter: $route.query.chapter,
                  questionNo: '練習問題',
                },
              }"
              >練習問題</router-link
            >
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  created() {
    console.log("route", this.$route);
  },
};
</script>
<style scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>